export const columns = [
  {
    accessorKey: "consignee",
    header: "Consignee",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "ntnNumber",
    header: "NTN Number",
    type: "string",
    size: 180,
  },
  {
    accessorKey: "consigneeAddress",
    header: "Consignee Address",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    size: 130,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    size: 140,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
